<template>
  <div id="departments">
    <div style="height: 3px;"></div>
    <div style="padding: 6px;"> </div>

    <!-- <el-form :inline="true" ref="form" :model="queryMap" label-width="70px" size="small">
      <el-form-item label="用户名">
        <el-input @keyup.enter.native="searchUser" @clear="searchUser" clearable v-model="queryMap.username"
          :placeholder="$t('message.placeholder.input')"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="reset" icon="el-icon-refresh">{{$t('message.button.reset')}}</el-button>
        <el-button type="primary" @click="searchUserGroup" icon="el-icon-search">{{$t('message.button.search')}}</el-button>
        <el-button type="success" icon="el-icon-plus" @click="searchUserGroup = true">{{$t('message.button.add')}}</el-button>
        <el-button type="danger" icon="el-icon-plus" @click="removeCheckbox">{{$t('message.button.delete')}}</el-button>
        <el-button @click="downExcel" icon="el-icon-download">{{$t('message.button.export')}}</el-button>
      </el-form-item>
    </el-form> -->
    <div>
      <el-button 
        class="btn btn1" 
        icon="el-icon-circle-plus-outline"  
        @click="searchUserGroup = true"
        :disabled="!addTableListPriv"
        :class="!addTableListPriv ? 'btnDisable' : ''"
        >{{$t('message.button.add')}}
      </el-button>
      <el-button 
        class="btn btn2"  
        icon="el-icon-delete" 
        @click="removeCheckbox" 
        :disabled='!removeBtnPriv'
        :class="!removeBtnPriv ? 'btnDisable' : ''"
        >{{$t('message.button.delete')}}
      </el-button>
    </div>

    <el-dialog class="searchAddBomList" v-if='searchUserGroup' :title="$t('message.title.add')" :visible.sync="searchUserGroup" >
      <AddUserGroup @listDbClick="addList"></AddUserGroup>
    </el-dialog>
    <div style="padding: 10px 20px; height: 5%;">
      <!-- 表格区域 -->
      <vxe-grid 
        ref='xGrid' 
        v-bind="gridOptions" 
        @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent">
        <template #bottom>
          <div class="alert-message">
            <span class="alert-message-content">
              <div>{{ $t('message.title.Checked') + selectRecords.length + $t('message.title.resultsNums')}} {{ $t('message.title.totalResults') + totalRecords + $t('message.title.resultsNums')}}</div>
            </span>
          </div>
        </template>
      </vxe-grid>
    </div>
  
  </div>
</template>

<style></style>

<script>

  import axios from "axios";
  import AddUserGroup from '@/components/addUserGroup.vue';
  export default {
    data() {
      return {  
        queryMap:"",

        selectRecords: [],
        totalRecords:"",
        searchUserGroup:false,
        gridOptions: {
          keepSource: true,
          resizable: true,
          border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "520",
          size: "small",
          data: [],
          sortConfig: {
            trigger: 'cell'
          },
        },
        

        loading: true,
        rols_text: [], //表体显示内容
        get_change_info: "", //父组件传来的值

        //权限
        removeBtnPriv: false,
        addTableListPriv: false,
      }
    },
    components:{
      AddUserGroup,
    },
    mounted() {},

    methods: {
      checkboxChangeEvent ({ records }) {
        const $grid = this.$refs.xGrid;
        this.selectRecords = records;
      },

      addList(row) { //添加
        console.log(row);
        let arr = []
        for (let i = 0; i < this.gridOptions.data.length; i++) {
          const e = this.gridOptions.data[i];
          arr.push(e.itemId)
        }
        console.log(arr);
        if (arr.indexOf(row.id) === -1 ) {
          // this.searchUserGroup = false;
          
          let arr = [];
          
          let insertUserGroups = {};
          insertUserGroups.id = row.id;
          insertUserGroups.classId = row.classId; 

          arr.push(insertUserGroups);
          
          
          let obj = {...this.$store.state.objectId}
            // obj.id = this.$store.state.objectId.id+'';
            // obj.classId = this.$store.state.objectId.classId+'';
            // obj.subClassId = this.$store.state.objectId.subClassId+'';
          
          var userGroupList  = {
            tableId:95,
            userObjId:obj,
            insertUserGroups:arr
          }
          console.log(userGroupList);
          axios.post('/pmdm/admin/user/saveTable', userGroupList )
          .then(res => {
            console.log(res);
            if(res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              this.getUserGroup();
            }
          })
          .catch();
        } else{
            this.$message.error(this.$t('message.error.sameUser'));
        }
        
      },
      removeCheckbox(grid) { //删除
        let obj = {}
        obj.id = this.$store.state.objectId.id+'';
        obj.classId = this.$store.state.objectId.classId+'';
        obj.subClassId = this.$store.state.objectId.subClassId+'';
        console.log(this.$refs.xGrid);
        var removeRow = this.$refs.xGrid.getCheckboxRecords();
        console.log(removeRow);
        var del_table = [];
        var vm = this;
        if(removeRow.length == 0) {
          return false
        } else {          
          for(let i = 0; i < removeRow.length; i++) {
            const e = removeRow[i];
            del_table.push({
              id:e.itemId,
              classId:e.itemClassId
            });
          };
          //console.log(del_table);
          var userGroupList = {   
            tableId:95,
            userObjId:obj,
            deleteUserGroups: del_table
          };
          console.log(userGroupList);
          axios.post('/pmdm/admin/user/deleteTable', userGroupList).then(res => {
						if(res.data.code == 200) {
              this.$message({
								message: res.data.message,
								type: 'success'
              });
              //console.log(res);
              this.getUserGroup();
              this.selectRecords = [];
              
            }
					})
					.catch(function (error) {
						console.log(error);
					});
        }
        
      },
      async getUserGroup() {
        var change_info = this.$store.state.change_info;
        if (this.get_change_info == "") {
          change_info = this.$store.state.change_info;
        } else {
          change_info = this.get_change_info;
        };

        var obj_get = { //获取change
          ... this.$store.state.objectId,
//id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          //subClassId: this.$store.state.subClassId_,
          // changeId: change_info.changeId,
          // changeClassId: change_info.changeClassId,
          // changeSubClassId: change_info.changeSubClassId,
          tableId: 95
        };
        var loadTableUrl = `/pmdm/admin/user/loadTable${this.params(obj_get)}`;
        const { //获取标题
          data: res
        } = await this.$http.get(loadTableUrl);
        this.gridOptions.columns = this.getNewTableTitleData(res);
        this.rols_text = this.getNewTableContentData(res);
        this.gridOptions.data = this.rols_text;
        this.totalRecords = res.object.table.totalRecords;

      },
      loadUserPriv() {
        var priv_ = this.getUserContextPriv();
        //console.log(priv_);
        let subClass_Id = this.$store.state.objectId.subClassId;
        //console.log(subClass_Id);
        for (let i = 0; i < priv_.length; i++) {
            if (priv_[i].classId == subClass_Id) {
                //console.log(priv_[i]);
                if (priv_[i].type == 3) {
                    this.addTableListPriv = true;
                };
                if (priv_[i].type == 4) {
                    this.removeBtnPriv = true;
                }
            }
        }
      },
    },
    created() {
      this.getUserGroup();
      this.loadUserPriv();
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  
  };
</script>